import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ReactComponent as DownArrow } from "../../../assets/images/downArrow.svg";
import { ReactComponent as CrossIcon } from "../../../assets/images/crossIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/CrossInActive.svg";
import ToggleSwitch from "../../UniversalComponents/ToggleSwitch";
import CreateViewDialog from "./TableThead/CreateViewDialog";
import ManageColDialog from "./TableThead/ManageColDialog";
import AttachIcon from "../../../assets/images/icons/AttachIcon";
import NotesImg from "../../../assets/images/icons/NotesImg";
import EditImg from "../../../assets/images/icons/EditImg";
import { getTitleCase } from "../../../utils/utilityFunctions/stringUtility";
import List from "../../UniversalComponents/ListComponent";
import withPortalHOC from "../../UniversalComponents/WithPortalHOC";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import {
  usePostOptionDeleteMutation,
  usePostViewConfigurationMutation,
  usePostViewDeleteMutation,
} from "../../../utils/customer/customerListHeader";
// import icon from "../../../assets/images/NewPlusIcon.svg";
import {
  checkAccessPermission,
  getCompanyId,
  getIsOwner,
  getOrganizationId,
  getUserToken,
} from "../../../utils/utilityFunctions/localServices";
import Button from "../../UniversalComponents/DefaultButton";
import { pushAlert } from "../../../utils/alertSlice";
import ConfirmationDialogBox from "../../UniversalComponents/ConfirmationDialogBox";
import AddFieldDrawer from "./AddFieldDrawer";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { X } from "lucide-react";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import { ReactComponent as DeletIcons } from "../../../assets/images/NewDelete.svg";
import { ReactComponent as PlusIcon } from "../../../assets/images/NewPlusIcon.svg";
import { ReactComponent as EyeIcon } from "../../../assets/images/eyes.svg";
import { ReactComponent as HiddenEyeIcon } from "../../../assets/images/hiddeneyes.svg";

const corefields = [
  "tasks",
  "deal",
  "lead",
  "customer_name",
  "customer_display_name",
  "notes",
  "delegation",
  "website",
  "type",
  "business_category",
  "phone",
  "email",
  "customer_group",
  "country_id",
  "tax_no",
];

const PortalList = withPortalHOC(List);

const ManageViewDrawer = ({
  thead,
  ExtraFieldAddHeader,
  isAddFieldOpen,
  setIsAddFieldOpen,
  menuVisible,
  setMenuVisible,
  fromPage,
  view,
  handleChangeView,
  viewList,
  gridViewData,
  listViewData,
  handleFieldVisibility,
  refetchHeader,
  setNewViewName,
  handleReorderFields,
  isCreateView = false,
  fetchFieldOptions,
  fieldOptionsData,
  isSuccessOptions,
  isErrorOptions,
  isFetchingOptions,
  removeFieldApi,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [orderedThead, setOrderedThead] = useState([]);
  const [editFieldData, setEditFieldData] = useState(null);
  const [isListView, setIsListView] = useState(true);
  const [showCreateView, setShowCreateView] = useState(isCreateView);
  const [showViewList, setShowViewList] = useState(false);
  const [groupIds, setGroupIds] = useState([]);
  const [assignRole, setAssignRole] = useState(false);

  const [newView, setNewView] = useState("");
  const [isEditView, setIsEditView] = useState("");
  const dispatch = useDispatch();

  const [postViewConfiguration, { isSuccess: isViewCreationSuccess }] = usePostViewConfigurationMutation();

  const [viewToDelete, setViewToDelete] = useState(null);
  const [showConfirmationBox, setShowConfirmationBox] = useState(false);
  const [isColumnReordered, setIsColumnReordered] = useState(false);
  const [confirmationText, setConfirmationText] = useState("Are you sure want to discard this draft ?");

  console.log("viewDelete APi", usePostViewDeleteMutation());

  //memoize the options and toggleButtons and selectedOptions to avoid rerender issue in the portal list component

  const memoizedOptions = useMemo(() => {
    if (!viewList) return [];
    const hasMultiplePublicViews = viewList.filter((item) => item.view_access).length > 1;
    return viewList.map((option) => ({
      label: option.view_name,
      value: option.view_name,
      ...(hasMultiplePublicViews
        ? {
            toggleType: option.view_name !== "Default" && option.view_access ? "Public" : "Private",
          }
        : {}),
    }));
  }, [viewList]);

  const toggleButtons = useMemo(() => {
    if (!viewList) return [];
    return viewList.filter((item) => item.view_access).length > 1 ? ["Private", "Public"] : [];
  }, [viewList]);

  const selectedOptions = useMemo(() => {
    if (!viewList || !view) return [];
    return viewList
      .filter((item) => item.view_name === view.view_name)
      .map((option) => ({
        label: option.view_name,
        value: option.view_name,
        toggleType: option.view_name !== "Default" && option.view_access ? "Public" : "Private",
      }));
  }, [viewList, view]);

  const [
    postViewDelete,
    {
      data: postViewDeleteResponse,
      isSuccess: isViewDeleteSuccess,
      isError: isViewDeleteError,
      isLoading: isViewDeleteLoading,
    },
  ] = usePostViewDeleteMutation();

  const ref = useRef();

  useEffect(() => {
    //loading
    if (isViewDeleteLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isViewDeleteSuccess) {
      dispatch(
        pushAlert({
          message: postViewDeleteResponse.message,
          type: postViewDeleteResponse.success ? "success" : "danger",
          visible: true,
        })
      );
      if (postViewDeleteResponse?.success) {
        if (view.view_name === viewToDelete?.view_name) {
          setNewViewName("Default");
          handleChangeView("Default");
        } else {
          refetchHeader();
        }
        setViewToDelete(null);
      }
    }
    // catch block
    if (isViewDeleteError) {
      dispatch(pushAlert({ message: postViewDeleteResponse?.message, type: "danger", visible: true }));
    }
  }, [isViewDeleteSuccess, isViewDeleteError, isViewDeleteLoading]);

  useEffect(() => {
    setOrderedThead(thead);
  }, [thead]);

  const CreateExtraField = () => {
    if (editFieldData) {
      setEditFieldData(null);
    } else {
      setIsAddFieldOpen(!isAddFieldOpen);
    }
  };

  const EditExtraField = (e, headeritem) => {
    const filteredItem = orderedThead?.find((item) => item.value === headeritem);
    setEditFieldData({
      field_label: filteredItem?.label,
      field_type: filteredItem?.type,
      field_value: filteredItem?.value,
      field_id: filteredItem?.id,
      field_option: fieldOptionsData?.data ? fieldOptionsData.data : [],
      decimalPlaces: filteredItem?.meta?.numberFormat?.decimalPlaces,
      negativeFormat: filteredItem?.meta?.numberFormat?.negativeFormat,
      selectedOption: filteredItem?.meta?.numberFormat?.selectedOption,
      separators: filteredItem?.meta?.numberFormat?.separators,
      symbol: filteredItem?.meta?.numberFormat?.symbol,
      textSelectedOption: filteredItem?.meta?.textFormat?.textSelectedOption,
    });

    if (filteredItem?.type === "dropdown" || filteredItem?.type === "multiselect") {
      fetchFieldOptions(filteredItem?.value);
    }
    setIsAddFieldOpen(true);
  };

  // useEffect(() => {
  //   if (fieldOptionsData?.data) {
  //     setEditFieldData((prev) => ({ ...prev, field_options: fieldOptionsData.data }));
  //   }
  // }, [fieldOptionsData?.data]);

  useEffect(() => {
    if (isFetchingOptions) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    if (isSuccessOptions && !isFetchingOptions) {
      if (fieldOptionsData.success) {
        setEditFieldData((prev) => ({ ...prev, field_options: fieldOptionsData.data }));
      }
    }
    if (isErrorOptions) {
    }
  }, [isSuccessOptions, isFetchingOptions, isErrorOptions]);

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleDragStart = (headerItem, index) => {
    setDraggedItem({ headerItem, index });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = (status, targetIndex) => {
    handleReorderFields(draggedItem.index, targetIndex);
    if (draggedItem.index !== targetIndex) setIsColumnReordered(true);
  };

  const userData = useSelector((store) => store?.user);

  const handleToggle = (state) => {
    setIsListView(state);
  };

  const handleUpdateView = async () => {
    const payload = {
      company_id: getCompanyId(),
      org_id: getOrganizationId(),
      view_name: newView ? newView : view.view_name,
      is_group_view: newView ? false : view.view_access,
      visible_fields: listViewData?.visible_fields,
      hidden_fields: listViewData?.hidden_fields,
    };

    if (isEditView) {
      payload.updated_view_name = newView;
      payload.view_name = isEditView;
    }

    if (assignRole) payload.assign_to_role = true;

    if (groupIds.length) payload.assignee_group_ids = groupIds;

    try {
      const result = await postViewConfiguration({ payload, token: getUserToken() }).unwrap();
      if (result?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: result?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  useEffect(() => {
    if (isViewCreationSuccess) {
      const tempView = { view_name: newView, view_access: assignRole };

      setNewViewName(newView);
      setNewView("");
      setGroupIds([]);
      // handleChangeView(tempView);
      refetchHeader();
      setMenuVisible();
    }
  }, [isViewCreationSuccess]);

  const handleViewCreate = (editView) => {
    if (editView) {
      const editingView = viewList.filter((view) => view.view_name === editView)[0];
      setIsEditView(editingView.view_name);
      setAssignRole(editingView.view_access);
      setGroupIds(editingView.groupIds);
    } else {
      setIsEditView("");
      setAssignRole(false);
      setGroupIds([]);
    }
    setShowCreateView(true);
    setShowViewList(false);
  };

  // const listCloseOutsideClick = useClickOutside(() => {
  //   setShowViewList((prev) => !prev);
  // });

  const HandleConfirmationBox = (deleteView) => {
    console.log("deleteView", deleteView);
    if (deleteView?.view_name) {
      setShowViewList(false);
      // setConfirmationText(`Are you sure you want to delete ${deleteView?.view_name} view permanently?`);
      setConfirmationText(
        <span className="text-justify">
          Deleting this view may prevent users from accessing the data associated with it.
        </span>
      );
      setShowConfirmationBox(true);
      setViewToDelete(deleteView);
      return;
    }

    if ((((view?.view_access && getIsOwner()) || !view?.view_access) && view.view_name !== "Default") || newView) {
      if (newView.length) {
        setConfirmationText("View has not created, Do you want to discard changes?");
        setShowConfirmationBox(true);
      } else if (isColumnReordered) {
        setConfirmationText("Do you want to discard changes?");
        setShowConfirmationBox(true);
      } else setMenuVisible(false);
    } else {
      setMenuVisible(false);
    }
  };

  const handleDeleteView = () => {
    postViewDelete({
      payload: {
        view_name: viewToDelete?.view_name,
        company_id: getCompanyId(),
        type: viewToDelete?.view_access ? "public" : "private",
      },
    });
  };

  const handleConfirmClick = () => {
    if (viewToDelete) {
      handleDeleteView(viewToDelete);
    } else setMenuVisible(false);
    setShowConfirmationBox(false);
    setConfirmationText("");
  };

  const handleViewChanges = (selected) => {
    // onChange({
    //   target: { value: selectedOptions.map((item) => item.value), name: id, ...selectedOptions?.[0]?.additionFields },
    // });
    // onChange( value);
  };

  const [optionsDelete] = usePostOptionDeleteMutation();

  const handleDeleteOption = (choice, fieldName) => {
    if (!choice?.id) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Invalid option ID",
          type: "danger",
        })
      );
      return;
    }

    const payload = {
      id: choice.id,
      company_id: getCompanyId(),
    };

    optionsDelete({ payload })
      .unwrap()
      .then((result) => {
        if (result?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Option deleted successfully",
              type: "success",
            })
          );
          fetchFieldOptions(fieldName);
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Failed to delete option",
              type: "danger",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          pushAlert({
            visible: true,
            message: error?.data?.message || "Something went wrong while deleting option",
            type: "danger",
          })
        );
      });
  };

  return (
    <CustomDrawer open={menuVisible} onClose={() => setMenuVisible(false)}>
      {showCreateView ? (
        <CreateViewDialog
          goBack={() => setShowCreateView(false)}
          groupIds={groupIds}
          setGroupIds={setGroupIds}
          handleCreateView={(newView) => {
            setNewView(newView.trim());
          }}
          isEditView={isEditView}
          assignRole={assignRole}
          setAssignRole={setAssignRole}
        />
      ) : (
        <div className="relative h-full flex flex-col">
          <div className="border-b ">
            <div className="flex items-center justify-between p-3">
              <div
                className="flex items-center gap-2 cursor-pointer"
                // ref={ref}
              >
                <h3
                  onClick={() => setShowViewList(!showViewList)}
                  ref={ref}
                  className="text-primary font-semibold text-18 flex items-center hover:bg-[#CECECE4D] rounded-md h-full w-full  px-2 py-1"
                >
                  <span className="max-w-[8ch] min-w-[8ch] text-ellipsis overflow-hidden whitespace-nowrap ">
                    {newView ? newView : view?.view_name}{" "}
                  </span>
                  <DownArrow
                    fill={`#1D4469`}
                    className={`${showViewList ? "rotate-180" : "rotate-0"} transition-all duration-300 text-primary`}
                  />{" "}
                </h3>
                {showViewList && (
                  <>
                    <PortalList
                      open={showViewList}
                      onClose={() => setShowViewList(false)}
                      containerRef={ref}
                      width="170px"
                      options={memoizedOptions}
                      showSearch
                      toggleButtons={toggleButtons}
                      // sels = {designationList?.filter((option) => option.department === formData['email_id']).map((option) => ({
                      //   label: option?.department,
                      //   value: option?.department,
                      // }))}
                      selectedOptions={selectedOptions}
                      onOptionClick={(data) => {
                        handleChangeView(data[0].value);
                        setShowViewList(false);
                      }}
                      // isEditList={getIsOwner()}
                      editListHandler={(option) =>
                        handleViewCreate(viewList?.filter((item) => item.view_name === option.value)[0].view_name)
                      }
                      deleteOptionHandler={(option) =>
                        HandleConfirmationBox(viewList?.find((item) => item.view_name === option.value))
                      }
                      noChildren
                      addButton
                      addButtonLabel="Create New View"
                      addButtonAction={() => handleViewCreate()}
                    />
                  </>
                )}
              </div>
              <div className="flex items-center gap-4">
                {/* <ToggleSwitch
                  leftEle={<ListIcon />}
                  rightEle={<GridIcon />}
                  onToggle={handleToggle}
                  className={"w-32"}
                /> */}
                <span className="float-right text-20 cursor-pointer" onClick={HandleConfirmationBox}>
                  <CrossIcon className="w-4 h-4 mr-3" />
                </span>
              </div>
            </div>
          </div>
          {checkAccessPermission("Add & Edit Customer") && (
            <div
              className="flex gap-2 items-center justify-center p-2 border shadow-2 m-3 cursor-pointer"
              onClick={() => {
                CreateExtraField();
              }}
            >
              {/* <img src={icon} alt="AddIcon" className="text-[#004EFF]" /> */}
              <PlusIcon className=" text-primary w-4 h-4" />

              <span className=" text-14 font-Inter text-primary font-medium">Add Fields</span>
            </div>
          )}

          {isListView && (
            <div className="px-4 py-1 w-full bg-white flex flex-col h-full min-h-0">
              {/* ===================== Visible Fields (AUTO HEIGHT) ===================== */}
              {listViewData?.visible_fields && (
                <div className="flex flex-col items-start gap-2 min-h-0 grow overflow-y-auto">
                  {/* Header */}
                  <div className="flex gap-3 items-center shrink-0">
                    <span className="w-7 h-7 rounded-full bg-[#DBEAFE] flex justify-center items-center">
                      <EyeIcon className="w-4 h-4" />
                    </span>
                    <h4 className="text-[#131313CC] font-poppins font-bold text-14">Visible Fields</h4>
                    <span className="w-7 h-7 rounded-full bg-[#DBEAFE] flex justify-center items-center">
                      <p className="text-xs text-[#155DFC] font-normal">{listViewData.visible_fields.length}</p>
                    </span>
                  </div>

                  {/* List */}
                  <div className="w-full flex flex-col overflow-y-auto thinscrollbar pr-2">
                    {listViewData.visible_fields.map((field, index) => (
                      <div
                        key={index}
                        className={`w-full border px-4 py-3 border-[#E5E7EB] group cursor-pointer bg-[#FFFFFF] hover:bg-[#004EFF0D]/5 rounded-xl flex justify-between items-center my-2 ${
                          dragOverIndex === index ? "bg-gray-200" : ""
                        }`}
                        draggable
                        onDragStart={() => handleDragStart(field, index)}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) => handleDrop(true, index)}
                      >
                        <div className="flex items-center">
                          <button className="cursor-grab">
                            <i className="bi bi-grip-vertical mr-2 text-CCD4DC hover:text-667279"></i>
                          </button>

                          <div className="mr-2">
                            <input
                              type="checkbox"
                              className="peer appearance-none w-4 h-4 border border-gray-400 rounded-sm
                    checked:bg-[var(--color-primary)] checked:border-[var(--color-primary)]
                    focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:ring-offset-1
                    cursor-pointer"
                              id={`checkbox-${index}`}
                              checked
                              onChange={() => handleFieldVisibility(field)}
                            />
                            <label htmlFor={`checkbox-${index}`} className="bottom-[15px]"></label>
                          </div>

                          <span className="checkbox-label capitalize flex items-center gap-1">
                            {orderedThead?.find((item) => item.value === field)?.label}
                            <span className="text-xs text-primary bg-primary-hover group-hover:bg-primary-15 px-2 ms-2 rounded">
                              {getTitleCase(orderedThead?.find((item) => item.value === field)?.type || "null")}
                            </span>
                          </span>
                        </div>

                        <div className="flex items-center">
                          {checkAccessPermission("Add & Edit Customer") &&
                            !corefields.includes(field) &&
                            orderedThead?.find((item) => item.value === field)?.type !== "task_template" && (
                              <div className="me-1 gap-4 flex items-center">
                                {field && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      EditExtraField(e, field);
                                    }}
                                  >
                                    <i
                                      className="bi bi-pencil-fill text-gray-400 
                          opacity-20 group-hover:opacity-100 
                          active:text-[#1D4469] transition-all duration-150"
                                    ></i>
                                  </button>
                                )}

                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFieldApi(field);
                                  }}
                                  className="text-gray-500 me-2 text-center justify-center 
                        opacity-20 group-hover:opacity-100 
                        active:text-[#1D4469] transition-all duration-150"
                                >
                                  <DeletIcons />
                                </button>
                              </div>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ===================== Hidden Fields (MAX 50%) ===================== */}
              {listViewData?.hidden_fields && (
                <div className="flex flex-col items-start gap-2 flex-none max-h-[50%] min-h-0 py-2">
                  {/* Header */}
                  <div className="flex gap-3 items-center shrink-0">
                    <span className="w-7 h-7 rounded-full bg-[#F3F4F6] flex justify-center items-center">
                      <HiddenEyeIcon className="w-4 h-4" />
                    </span>
                    <h4 className="text-[#131313CC] font-poppins font-bold text-14">Hidden Fields</h4>
                    <span className="w-7 h-7 rounded-full bg-[#F3F4F6] flex justify-center items-center">
                      <p className="text-xs text-[#4A5565] font-normal">{listViewData.hidden_fields.length}</p>
                    </span>
                  </div>

                  {/* List */}
                  <div className="w-full min-h-0 overflow-y-auto thinscrollbar pr-2">
                    {listViewData.hidden_fields.map((field, index) => (
                      <div
                        key={index}
                        className="w-full border px-4 py-3 cursor-pointer border-[#E5E7EB] bg-[#FFFFFF] opacity-60 rounded-xl flex justify-between items-center my-2 group"
                      >
                        <div className="flex items-center">
                          <button className="cursor-default">
                            <i className="bi bi-grip-vertical mr-2 text-CCD4DC"></i>
                          </button>

                          <div className="mr-2">
                            <input
                              type="checkbox"
                              className="focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:ring-offset-1 cursor-pointer"
                              id={`checkboxHidden-${index}`}
                              checked={false}
                              onChange={() => handleFieldVisibility(field)}
                            />
                            <label htmlFor={`checkboxHidden-${index}`} className="bottom-[15px]"></label>
                          </div>

                          <span className="checkbox-label capitalize text-[#888888] flex items-center gap-1">
                            {orderedThead?.find((item) => item.value === field)?.label}
                            <span className="text-xs text-primary bg-primary-active px-2 ms-2 rounded">
                              {getTitleCase(orderedThead?.find((item) => item.value === field)?.type)}
                            </span>
                          </span>
                        </div>

                        <div className="flex items-center">
                          {checkAccessPermission("Add & Edit Customer") &&
                            !corefields.includes(field) &&
                            orderedThead?.find((item) => item.value === field)?.type !== "task_template" && (
                              <div className="me-3 gap-4 flex items-center">
                                {field && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      EditExtraField(e, field);
                                    }}
                                  >
                                    <i className="bi bi-pencil-fill text-gray-400 hover:text-667279 opacity-20 group-hover:opacity-100"></i>
                                  </button>
                                )}

                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFieldApi(field);
                                  }}
                                  className="text-gray-500 text-center justify-center hover:text-667279 opacity-20 group-hover:opacity-100"
                                >
                                  <DeletIcons />
                                </button>
                              </div>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {!isListView && gridViewData && (
            <div className="grow min-h-0 overflow-auto thinscrollbar">
              {["general_fields", "additional_fields"].map((field, index) => (
                <ManageColDialog
                  field={getTitleCase(field)}
                  fieldData={gridViewData[field]}
                  key={index}
                  openDropDown={index === 0}
                  handleFieldVisibility={handleFieldVisibility}
                  orderedThead={orderedThead}
                  EditExtraField={EditExtraField}
                />
              ))}
            </div>
          )}

          {fromPage !== "All Tasks" && (
            <div className="border-t-2">
              {!isListView && gridViewData.generic_fields && (
                <div className="flex space-x-2 m-3 ">
                  {gridViewData.generic_fields.notes && (
                    <button onClick={() => handleFieldVisibility("notes")}>
                      <AttachIcon isActive={gridViewData.generic_fields.notes.visibility} />
                    </button>
                  )}
                  {gridViewData.generic_fields.tasks && (
                    <button onClick={() => handleFieldVisibility("tasks")}>
                      <NotesImg isActive={gridViewData.generic_fields.tasks.visibility} />
                    </button>
                  )}
                  {gridViewData.generic_fields.delegation && (
                    <button onClick={() => handleFieldVisibility("delegation")}>
                      <EditImg isActive={gridViewData.generic_fields.delegation.visibility} />
                    </button>
                  )}
                </div>
              )}
              <div className="flex justify-end space-x-4 m-5">
                {((((view?.view_access && getIsOwner()) || !view?.view_access) && view.view_name !== "Default") ||
                  newView) && (
                  // <button
                  //   className="border-1 border-2999BC py-2 px-16 rounded font-poppins text-16 font-400  bg-2999BC text-white"
                  //   onClick={() => {
                  //     handleUpdateView();
                  //     // ApplyHeader();
                  //     // handlePostThead(orderedThead);
                  //     // setTimeout(() => {
                  //     //   handleMenuToggle();
                  //     // }, 400);
                  //   }}
                  // >
                  //   Apply
                  // </button>
                  <Button variant={"primary"} onClick={() => handleUpdateView()}>
                    Apply
                  </Button>
                )}
              </div>
            </div>
          )}

          {isAddFieldOpen && (
            <AddFieldDrawer
              open={isAddFieldOpen}
              onClose={() => {
                setIsAddFieldOpen(false);
                setEditFieldData(null);
              }}
              ExtraFieldAddHeader={ExtraFieldAddHeader}
              EditFieldData={editFieldData}
              handleDeleteOption={handleDeleteOption}
            />
          )}
        </div>
      )}
      {showConfirmationBox && (
        // <ConfirmationDialogBox
        //   open={showConfirmationBox}
        //   onClose={() => {
        //     setConfirmationText("Changes pending, Do you want to discard?");
        //     setShowConfirmationBox(false);
        //   }}
        //    title={viewToDelete.viwe_name ? "Delete":""}
        //   message={confirmationText}
        //   onConfirm={handleConfirmClick}
        // />

        <ConfirmationDialog
          open={showConfirmationBox}
          onConfirm={() => handleConfirmClick()}
          onClose={() => setShowConfirmationBox(false)}
          title={viewToDelete?.view_name ? "Delete View Confirmation" : "Discard?"}
          message={confirmationText}
          confirmVariant={viewToDelete?.view_name ? "delete" : "discard"}
          confirmText={viewToDelete?.view_name ? "Delete" : "Yes"}
          cancelText={viewToDelete?.view_name ? "Cancel" : "No"}
          iconVariant={viewToDelete?.view_name ? "delete" : "discard"}
        />
      )}
    </CustomDrawer>
  );
};
export default ManageViewDrawer;

const ListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="currentColor">
    <path d="M0 1C0 0.586 0.336 0.25 0.75 0.25H1.75C2.164 0.25 2.5 0.586 2.5 1C2.5 1.414 2.164 1.75 1.75 1.75H0.75C0.336 1.75 0 1.414 0 1ZM1.75 5.25H0.75C0.336 5.25 0 5.586 0 6C0 6.414 0.336 6.75 0.75 6.75H1.75C2.164 6.75 2.5 6.414 2.5 6C2.5 5.586 2.164 5.25 1.75 5.25ZM1.75 10.25H0.75C0.336 10.25 0 10.586 0 11C0 11.414 0.336 11.75 0.75 11.75H1.75C2.164 11.75 2.5 11.414 2.5 11C2.5 10.586 2.164 10.25 1.75 10.25ZM4 1C4 0.586 4.336 0.25 4.75 0.25H15.75C16.164 0.25 16.5 0.586 16.5 1C16.5 1.414 16.164 1.75 15.75 1.75H4.75C4.336 1.75 4 1.414 4 1ZM15.75 5.25H4.75C4.336 5.25 4 5.586 4 6C4 6.414 4.336 6.75 4.75 6.75H15.75C16.164 6.75 16.5 6.414 16.5 6C16.5 5.586 16.164 5.25 15.75 5.25ZM15.75 10.25H4.75C4.336 10.25 4 10.586 4 11C4 11.414 4.336 11.75 4.75 11.75H15.75C16.164 11.75 16.5 11.414 16.5 11C16.5 10.586 16.164 10.25 15.75 10.25Z" />
  </svg>
);

const GridIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 13 12" fill="currentColor">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0167 0.0415039C11.7748 0.0415039 12.417 0.683669 12.417 1.44176V4.12311C12.417 4.88122 11.7748 5.52338 11.0167 5.52338H8.33539C7.57726 5.52338 6.93511 4.88122 6.93511 4.12311V1.44176C6.93511 0.683669 7.57726 0.0415039 8.33539 0.0415039H11.0167ZM11.2253 1.44176C11.2253 1.34183 11.1167 1.23321 11.0167 1.23321H8.33539C8.23545 1.23321 8.12684 1.34183 8.12684 1.44176V4.12311C8.12684 4.22305 8.23545 4.33166 8.33539 4.33166H11.0167C11.1167 4.33166 11.2253 4.22305 11.2253 4.12311V1.44176Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.58138 0.0415039C5.33948 0.0415039 5.98164 0.683669 5.98164 1.44176V4.12311C5.98164 4.88122 5.33948 5.52338 4.58138 5.52338H1.90003C1.14192 5.52338 0.49977 4.88122 0.49977 4.12311V1.44176C0.49977 0.683669 1.14192 0.0415039 1.90003 0.0415039H4.58138ZM4.78993 1.44176C4.78993 1.34183 4.6813 1.23321 4.58138 1.23321H1.90003C1.80011 1.23321 1.69148 1.34183 1.69148 1.44176V4.12311C1.69148 4.22305 1.80011 4.33166 1.90003 4.33166H4.58138C4.6813 4.33166 4.78993 4.22305 4.78993 4.12311V1.44176Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.417 7.87689C12.417 7.11878 11.7748 6.47663 11.0167 6.47663H8.33539C7.57726 6.47663 6.93511 7.11878 6.93511 7.87689V10.5582C6.93511 11.3163 7.57726 11.9585 8.33539 11.9585H11.0167C11.7748 11.9585 12.417 11.3163 12.417 10.5582V7.87689ZM11.0167 7.66834C11.1167 7.66834 11.2253 7.77697 11.2253 7.87689V10.5582C11.2253 10.6582 11.1167 10.7668 11.0167 10.7668H8.33539C8.23545 10.7668 8.12684 10.6582 8.12684 10.5582V7.87689C8.12684 7.77697 8.23545 7.66834 8.33539 7.66834H11.0167Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.58138 6.47663C5.33948 6.47663 5.98164 7.11878 5.98164 7.87689V10.5582C5.98164 11.3163 5.33948 11.9585 4.58138 11.9585H1.90003C1.14192 11.9585 0.49977 11.3163 0.49977 10.5582V7.87689C0.49977 7.11878 1.14192 6.47663 1.90003 6.47663H4.58138ZM4.78993 7.87689C4.78993 7.77697 4.6813 7.66834 4.58138 7.66834H1.90003C1.80011 7.66834 1.69148 7.77697 1.69148 7.87689V10.5582C1.69148 10.6582 1.80011 10.7668 1.90003 10.7668H4.58138C4.6813 10.7668 4.78993 10.6582 4.78993 10.5582V7.87689Z"
    />
  </svg>
);
